import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component'; 
import { SharedModule } from 'src/app/shared/shared.module';
import { AcLayoutComponent } from './ac-layout/ac-layout.component';
import { RouterModule } from '@angular/router';
import { routes } from 'src/app/routes/routes';
import { NgxSelectModule } from 'ngx-select-ex';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule } from '@angular/forms';

import { LayoutModule as lay } from 'src/app/layout/layout.module';
import { AcSidebarComponent } from './ac-sidebar/ac-sidebar.component';
import { AcHeaderComponent } from './ac-header/ac-header.component';


@NgModule({
  declarations: [
    LayoutComponent, 
    AcLayoutComponent, AcSidebarComponent, AcHeaderComponent
  ],
  imports: [
    SharedModule,   
    CommonModule,
    RouterModule.forChild(routes),
    NgxSelectModule,
    NgxDatatableModule,
    FormsModule,
    lay
  ],
  exports: [
    RouterModule
]
})
export class LayoutsModule { }
